const index = () => import(/* webpackChunkName: "herb" */ './Index');
const manager = () => import(/* webpackChunkName: "herb" */ './managerIndex');
const progress = () => import(/* webpackChunkName: "herb" */ './progIndex');
const stat = () => import(/* webpackChunkName: "herb" */ './statIndex');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/inves/inves/v2020/index',
      name: 'inves_inves_v2020_index',
      component: index
    },
    {
      path: '/inves/inves/v2020/manager',
      name: 'inves_inves_v2020_manager',
      component: manager
    },
    {
      path: '/inves/inves/v2020/prog',
      name: 'inves_inves_v2020_progress',
      component: progress
    },
    {
      path: '/inves/inves/v2020/stat',
      name: 'inves_inves_v2020_stat',
      component: stat
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/inves/inves/v2020/router.js